import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "eventStatus",
  standalone: true,
})
export class EventStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case "published":
        return "Publicado";
      case "draft":
        return "Rascunho";
      case "cancelled":
        return "Cancelado";
      case "pending_approval":
        return "Pendente Aprovação";
      default:
        return value;
    }
  }
}
